// Dashboard calendar (ERB + Stimulus) status helpers + date utilities.
// Status colours come from the BLUME design system: getStatusPillClass maps an
// Event status_display label to a .bz-pill--<status> modifier (status.css), so
// JS-rendered chips track the same palette as the server-rendered ones. Keep in
// sync with app/helpers/bz_status_helper.rb (BZ_STATUS_PILL_CLASS).
export const STATUS_PILL_CLASS = {
  'Quick Quote': 'bz-pill--quick-quote',
  'Inquiry': 'bz-pill--inquiry',
  'Quote Sent': 'bz-pill--quote-sent',
  'Quote Confirmed': 'bz-pill--quote-confirmed',
  'Quote Declined': 'bz-pill--quote-declined',
  'Deposit Paid': 'bz-pill--deposit-paid',
  'In Progress': 'bz-pill--in-progress',
  'Flower Order Submitted': 'bz-pill--in-progress',
  'Event Completed': 'bz-pill--completed',
  'Completed': 'bz-pill--completed',
  'Invoice Paid': 'bz-pill--completed',
  'Event Cancelled': 'bz-pill--cancelled',
  'Cancelled': 'bz-pill--cancelled',
  'Event Archived': 'bz-pill--cancelled'
}

export function getStatusPillClass(status) {
  return STATUS_PILL_CLASS[status] || 'bz-pill--inquiry'
}

export function formatDateISO(date) {
  return date.toISOString().slice(0, 10)
}

export function formatDateDisplay(date) {
  return date.toLocaleDateString(undefined, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

export function getMonthNames() {
  return Array.from({ length: 12 }, (_, i) =>
    new Date(2000, i, 1).toLocaleString(undefined, { month: 'long' })
  )
}
